import { createAsyncThunk } from '@reduxjs/toolkit';
import { TeamMemberInvites } from '../../models/TeamMemberInvites';

export const GetMyTeamMemberInvites = createAsyncThunk(
    'teamMemberInvites/getMyTeamMemberInvites',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get('/api/Associate/my-invites');
        if (response.status !== 200) {
            throw new Error('Failed to fetch team member invites');
        }
        return response.data as TeamMemberInvites;
    }
);
